import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  type: "button",
  class: "bg-primary-700 hover:bg-primary-600 rounded shadow-[0_0_4px_0px_rgb(17,24,39,0.25)] p-2 border border-transparent mx-1 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-primary-600"
}

import { useRouter } from "vue-router";
import ArrowTopRightIcon from "@/components/icons/arrowTopRightIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'GoToButton',
  props: {
	routeLink: {
		type: String,
		required: true,
	},
},
  setup(__props) {

const router = useRouter();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace(__props.routeLink))),
    target: "_blank"
  }, [
    _createElementVNode("button", _hoisted_1, [
      _createVNode(ArrowTopRightIcon, { class: "h-4 w-4 object-contain" })
    ])
  ]))
}
}

})